"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CardCheckbox;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _image = _interopRequireDefault(require("../../contentful-views/image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable jsx-a11y/label-has-for */

/**
 * This component is visually similar to a media card, but is a checkbox field.
 * We use the checkbox for storing the value, but hide it visually.
 * We use a <span className='card-checkbox/> to have a custom checkbox implementation.
 * @param {Object} props
 * @param {String} props.name Field name. Used by formik to recognize a field
 * @param {String} props.image Contentful Image media object
 * @param {String} props.label Label for the checkbox / title for the card
 */
function CardCheckbox(_ref) {
  var name = _ref.name,
      image = _ref.image,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CardCheckbox"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: name
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    id: name,
    name: name,
    component: "input",
    type: "checkbox"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-content"
  }, /*#__PURE__*/_react["default"].createElement(_image["default"], {
    media: image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-background"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "card-label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "card-checkbox"
  }), label))));
}

CardCheckbox.propTypes = {
  name: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].shape({}),
  label: _propTypes["default"].node
};
CardCheckbox.defaultProps = {
  image: {},
  label: null
};